// @ts-ignore
import SlideTransition from '@ivanv/vue-collapse-transition/src/CollapseTransition.vue'


export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.vueApp.component('GsSlideTransition', SlideTransition)
	const dayjs = useDayJS()
	const ts = useState('currentUTCTimestamp', () => dayjs.utc().unix())
	if (import.meta.client)
		useIntervalFn(() => ts.value =  dayjs.utc().unix(), 1000)
	//nuxtApp.provide('isClientSide', computed<boolean>(() => typeof window !== 'undefined'))
})
